import { useResetTimingServiceStatusMutation, useSetupTimingServiceStatusMutation } from "~/generated/graphql";
import Button from "./buttons/Button";

export const InitializeTimingServiceStatusButton = () => {
  const { mutateAsync: applyMigration } = useSetupTimingServiceStatusMutation();
  const { mutateAsync: resetTimingServiceStatus } = useResetTimingServiceStatusMutation();
  const apply = async () => {
    await resetTimingServiceStatus({});
    await applyMigration({});
  };
  return (
    <Button toolTip="Initialize Timing Service Status" onClick={apply}>
      Initialize Timing
    </Button>
  );
};
